export default {
  apiUrl: "/api",
};

export const BASE_URL = "https://agentstack.net/api"
